import React from 'react';
import { LayoutProvider } from './contexts/LayoutContext';
import { SnakExperience } from './components/SnakExperience';
type AppProps = {
  theme?: 'dark' | 'light';
  device?: 'responsive' | 'phone';
};
export function App({
  theme = 'dark',
  device = 'responsive'
}: AppProps) {
  const themeClass = theme === 'dark' ? 'theme-dark' : 'theme-light';
  if (device === 'phone') {
    return <div className="flex min-h-[100dvh] w-full items-center justify-center bg-[#E6E4DF] p-6" data-id="element-0" data-mp="2rkdwustqp9n8">
        <div className="h-[min(844px,calc(100dvh-48px))] w-[390px] max-w-full overflow-hidden rounded-[44px] border-[10px] border-[#111614] shadow-[0_30px_80px_rgba(0,0,0,0.25)]" data-id="element-1" data-mp="2mmcd05ohp6ap">
          <LayoutProvider className={`${themeClass} h-full w-full`} data-id="element-2" data-mp="2wk0av4he6tx3">
            <SnakExperience data-id="element-3" data-mp="2wip36tktt20p" />
          </LayoutProvider>
        </div>
      </div>;
  }
  return <LayoutProvider className={`${themeClass} h-[100dvh] min-h-[560px] w-full`} data-id="element-4" data-mp="28sbbj465l56n">
      <SnakExperience data-id="element-5" data-mp="23utby4e102bb" />
    </LayoutProvider>;
}